import { render, staticRenderFns } from "./Page_Brands.vue?vue&type=template&id=14698fc4&scoped=true&"
import script from "./Page_Brands.vue?vue&type=script&lang=js&"
export * from "./Page_Brands.vue?vue&type=script&lang=js&"
import style0 from "./Page_Brands.vue?vue&type=style&index=0&id=14698fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14698fc4",
  null
  
)

export default component.exports